import { BaseSearchModel } from "../query/base-search.model";

export class EmailTemplateSearchModel extends BaseSearchModel {
    name?: any;
    senderName?: any;
    senderEmail?: any;
}